export const AgeRangeConst = {
    '13-17': {
        id: 1,
        label: '13-17',
        minRange: '13',
        maxRange: '17'
    },
    '18-20': {
        id: 2,
        label: '18-20',
        minRange: '18',
        maxRange: '20'
    },
    '21-24': {
        id: 3,
        label: '21-24',
        minRange: '21',
        maxRange: '24'
    },
    '25-29': {
        id: 4,
        label: '25-29',
        minRange: '25',
        maxRange: '29'
    },
    '30-34': {
        id: 5,
        label: '30-34',
        minRange: '30',
        maxRange: '34'
    },
    '35-39': {
        id: 6,
        label: '35-39',
        minRange: '35',
        maxRange: '39'
    },
    '40-44': {
        id: 7,
        label: '40-44',
        minRange: '40',
        maxRange: '44'
    },
    '45-49': {
        id: 8,
        label: '45-49',
        minRange: '45',
        maxRange: '49'
    },
    '50-54': {
        id: 9,
        label: '50-54',
        minRange: '50',
        maxRange: '54'
    },
    '55-64': {
        id: 10,
        label: '55-64',
        minRange: '55',
        maxRange: '64'
    },
    '65+': {
        id: 11,
        label: '65+',
        minRange: '65+',
        maxRange: '65+'
    },
}